'use client';

import React from 'react';
import ElevatorTerminologyContent from './components/ElevatorTerminologyContent';

export default function ElevatorTerminologyPage() {
  return <ElevatorTerminologyContent />;
}